import { render, staticRenderFns } from "./AdminStudentsFieldsFilters.vue?vue&type=template&id=8a28eec8"
import script from "./AdminStudentsFieldsFilters.vue?vue&type=script&lang=js"
export * from "./AdminStudentsFieldsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports